import { registerSW } from "virtual:pwa-register";
import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";

import { initSentry } from "./config/sentry";

initSentry();
registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
